import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { IBriefPaymentSearchRequest } from "@shared/lib/types/briefPayment";
import { BRIEF_PAYMENT_QUERY_KEY } from "../constants";

export const useGetBriefPayments = (
  dataRequest: IBriefPaymentSearchRequest
) => {
  const { data, isFetching } = useQuery({
    queryKey: [...BRIEF_PAYMENT_QUERY_KEY, dataRequest],
    queryFn: () => BriefService.getBriefPayments(dataRequest),
  });

  return {
    payments: data?.data?.data || [],
    isFetching,
    totalCount: data?.data?.pagination?.totalCount || 0,
  };
};
